import React, { useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { lugarDeviceIns } from "services/services-mia/miakey";
import { Grid } from "@mui/material";

const tipoLabel = (cod) => {
    if (cod === "E") return "Entrada";
    if (cod === "S") return "Salida";
    if (cod === "A") return "Entrada / Salida";
    return cod;
};

export default function DesactivarModal({ updateList, kioscoId, kioscoDetail, closeModal }) {
    const [inRequest, setInRequest] = useState(false);

    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await lugarDeviceIns({
            gateDeviceId: kioscoId,
            gateLugarId: kioscoDetail.gateLugarId,
            gateLugarDeviceFecha: new Date().toISOString().substring(0, 10),
            gateLugarDeviceStatus: "B",
            gateLugarDeviceTipo: kioscoDetail.gateLugarDeviceTipo,
            gateDeviceRequiereEntrada: kioscoDetail.gateLugarDeviceRequiereEntrada,
            gateDeviceRequiereSalida: kioscoDetail.gateLugarDeviceRequiereSalida,
        }, credentials);

        handleResponse(
            response,
            "Configuración desactivada exitosamente",
            { setSnackbarInfo, setIsOpen: closeModal, setSelected, updateList }
        );

        setInRequest(false);
    };

    return (
        <Formik
            key={kioscoDetail?.gateLugarId ?? kioscoId}
            initialValues={{
                zona: kioscoDetail.gateZonaNombre ?? "",
                acceso: kioscoDetail.gateLugarNombre ?? "",
                fecha: kioscoDetail.gateLugarDeviceFecha ?? "",
            }}
            validationSchema={yup.object({})}
            onSubmit={(values, { setSubmitting }) => {
                try {
                    handleSubmit();
                } catch (e) {
                    setSnackbarInfo({ message: e.errmsg, severity: "error", open: true });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form className={styles.inputs} noValidate>
                <Grid container justifyContent={"center"} spacing={2}>
                    <Grid item xs={12} md={2}>
                        <FormikTextInput name="fecha" labelText="Fecha" disabled fullWidth />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <FormikTextInput name="zona" labelText="Zona" disabled fullWidth />
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <FormikTextInput name="acceso" labelText="Acceso" disabled fullWidth />
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Dar de Baja" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <CircularIndeterminate />}
                </Grid>
            </Form>
        </Formik>
    );
}
